




































import { Component, Prop } from 'vue-property-decorator';
import { CheckIcon, XIcon } from 'vue-feather-icons';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import Avatar from '@/components/common/Avatar.vue';
import { BModal } from 'bootstrap-vue';
import { FormMixin } from '@/mixins/FormMixin';
import { AdmiralError } from 'admiral-core';
import FormError from '@/components/common/forms/FormError.vue';
import { AuthAction } from '@/store/AuthModule';
import { Util } from '@/utils/Util';

@Component({
  components: {
    FormError,
    Avatar,
    XIcon,
    CheckIcon,
  },
})
export default class MagicLinkRedirectModal extends mixins(FormMixin, BaseMixin) {
  @Prop({ type: String, required: false })
  code?: string;

  unlocked = false;
  keepLocked = false;

  email?: string;

  async mounted() {
    (this.$refs['magic-link-redirect-modal'] as BModal).$on('shown', async () => {
      if (this.code) {
        await this.handleLogin(this.code);
      }
    });
  }
  cancel() {
    //
  }

  async handleLogin(code: string) {
    try {
      await this.$store.dispatch(`AuthModule/${AuthAction.LoginWithMagicLink}`, {
        code,
      });
      setTimeout(async () => {
        this.unlocked = true;
        await this.fetchDataAfterLogin();
        await Util.wait(1000);

        this.$emit('magic-link-login-success');
      }, 1000);
    } catch (e) {
      this.keepLocked = true;
      const apiErrors = this.exceptionErrors(e);
      this.addError(
        apiErrors[AdmiralError.LoginIncorrectMagicLinkCode],
        'incorrect-code',
        'Magic link ist ungültig.',
      );

      this.addError(
        apiErrors[AdmiralError.ExpiredMagicLinkCode],
        'expired',
        'Magic link ist abgelaufen.',
      );
      if (apiErrors[AdmiralError.ExpiredMagicLinkCode]) {
        this.email = apiErrors[AdmiralError.ExpiredMagicLinkCode];
      }
    }
  }
}
